import addAdvertisementProperty from "./addAdvertisementProperty";

const resolveToParentId = (id, childToParentIdMap) => {
  const numericId = Number(id);
  if (!Number.isFinite(numericId)) return null;
  return childToParentIdMap?.get?.(numericId) ?? numericId;
};

const mapOverCriteo = (
  mightLikeProductItem,
  criteoAdverts,
  childToParentIdMap = new Map(),
) => {
  if (!mightLikeProductItem) return [];
  if (!criteoAdverts?.length) return mightLikeProductItem;

  const mightLikeProductId = Number(mightLikeProductItem.productId);

  const matchingAdvert = criteoAdverts.find((criteoItem) => {
    const resolvedParentSkuId = resolveToParentId(
      criteoItem.ParentSKU,
      childToParentIdMap,
    );
    const resolvedProductId = resolveToParentId(
      criteoItem.ProductId,
      childToParentIdMap,
    );

    return (
      resolvedParentSkuId === mightLikeProductId ||
      resolvedProductId === mightLikeProductId
    );
  });

  return matchingAdvert && "LineItemID" in matchingAdvert
    ? addAdvertisementProperty(mightLikeProductItem, matchingAdvert)
    : mightLikeProductItem;
};

export default mapOverCriteo;
